import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import React from "react";

export function Copyright() {
    const frontendVersion = window?.env?.FRONTEND_VERSION || process.env.REACT_APP_FRONTEND_VERSION || 'X.Y.Z';

    return (
        <>
            <Typography variant="body2" color="textSecondary" align="center">
                {`BA Podcast v${frontendVersion} `}
                {`© ${new Date().getFullYear()} `}
                <Link color="inherit" href="https://buttonsystems.eu" target="_blank" rel="noopener noreferrer">
                    Button Systems, s.r.o.
                </Link>
            </Typography>
        </>
    );
}
